export default __webpack_public_path__ + "static/media/tnr.f85717da.ttf";